import { InjectionToken } from "@angular/core";

export const bookingStatusDataTestIdForCheckInCta = new InjectionToken<string>(
  "bookingStatusDataTestIdForCheckInCta",
);
export const favoriteSpaceDataTestId = new InjectionToken<string>(
  "favoriteSpaceDataTestId",
);
